import React, { useEffect } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { Link, useNavigate } from "react-router-dom";
import ReactApexChart from "react-apexcharts";
import "react-toastify/dist/ReactToastify.css";
import authService from "../services/authservices";
import { ToastContainer, toast } from "react-toastify";
import { ScaleLoader } from "react-spinners";
import { getUserDetails } from "../services/authservices";

function Strategies() {
  useEffect(() => {
    fetchUserDetails();
    getPlanDetails();
    fetchBalance();
    getStratagy();
    getFollowedStratagy();
    getSitedata();
  }, []);

  const [StratagyLoader, setStratagyLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [siteDatacomes, setSiteData] = useState("");
  const [StratagyList, setStratagyList, StratagyListref] = useState([]);

  const [state, setState] = useState({
    series: [
      {
        name: "Annual ROI",
        data: [0],
      },
    ],
    options: {
      chart: {
        type: "area",
        height: 350,
        zoom: {
          enabled: false,
        },
        toolbar: {
          tools: {
            download: false, // Disable the download button
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
        colors: ["#2ebd85"],
      },
      fill: {
        type: "solid",
        colors: ["#1b2a2a"],
      },
      title: {
        text: "",
        align: "left",
      },
      subtitle: {
        text: "",
        align: "left",
      },
      xaxis: {
        categories: ["Start"],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        labels: {
          show: true,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
    },
  });
  const [stateunfollow, setStateunfollow] = useState({
    series: [
      {
        name: "Annual ROI",
        data: [0],
      },
    ],
    options: {
      chart: {
        type: "area",
        height: 350,
        zoom: {
          enabled: false,
        },
        toolbar: {
          tools: {
            download: false, // Disable the download button
          },
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
        width: 2,
        colors: ["#2ebd85"],
      },
      fill: {
        type: "solid",
        colors: ["#1b2a2a"],
      },
      title: {
        text: "",
        align: "left",
      },
      subtitle: {
        text: "",
        align: "left",
      },
      xaxis: {
        categories: ["Start"],
        labels: {
          show: false,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      yaxis: {
        min: 0,
        max: 100,
        labels: {
          show: true,
        },
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
      },
      grid: {
        show: false,
      },
      legend: {
        show: false,
      },
    },
  });

  const [planDetails, setPlanDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fuelWallet, setFuelWallet] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [strategyDetails, setStrategyDetails] = useState("");

  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    uid: null,
    referralCode: null,
    referralUrl: null,
    botStatus: "DeActive",
    displayname: null,
    botActivatedAt: null,
    botDeactivatedAt: null,
    country: null,
    isAuthenticated: false,
    exchanges: [],
  });

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        type: "line", // You can change to 'bar' or other chart types
        height: 350,
      },
      xaxis: {
        categories: [],
        title: { text: "Date" },
      },
      yaxis: {
        title: { text: "Total Profit" },
      },
      stroke: {
        curve: "smooth",
      },
      title: {
        text: "Profit Over Last 3 Days",
        align: "center",
      },
    },
  });

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  // const getStratagy = async (data) => {
  //   try {
  //     setLoader(true);
  //     const token = localStorage.getItem("token");
  //     const response = await authService.topStratagies(token);
  //     setStratagyLoader(false);
  //     console.log(response, "response");
  //     if (response.status == true) {
  //       console.log(response.data,"response.data")
  //       if (response.data.length > 0) {

  //         if(response.result_chart.length > 0)
  //         {
  //           // let chart_resp = response.result_chart.filter(res => res.stratagy.toLowerCase() == options.stratagyName );
  //           let chart_resp = response.result_chart;
  //           if(chart_resp.length > 0)
  //           {
  //             const categories = chart_resp.map((item) => item.date);
  //             const profitData = chart_resp.map((item) => item.totalProfit);

  //             // const updatedSeries = response.data.map((options) => {
  //             //   //  const annualROI = options?.annualROI || 0;
  //             //   const annualROI = options?.profit_percentage || 0;
  //             //    console.log(annualROI,"annualROI")
  //             //    return {
  //             //      name: options.stratagyName || "Annual ROI",
  //             //      data: [0, annualROI],
  //             //       buttonLabel: options.buttonLabel || "Follow",
  //             //    };
  //             //  });

  //             //  const unFollowseries =  response.data.filter((option,index) => option.buttonLabel === "Unfollow")
  //             //  .map((options,index) => {
  //             //   // const annualROI = options?.annualROI || 0;
  //             //   const annualROI = options?.profit_percentage || 0;
  //             //   return {
  //             //     name: options.stratagyName || "Annual ROI",
  //             //     data: [0, annualROI],
  //             //      buttonLabel: options.buttonLabel || "Follow",
  //             //   };
  //             //  })

  //             //  console.log("Upted series:", unFollowseries);

  //              const maxYValue = Math.max(
  //                100,
  //               //  ...response.data.map((options) => options?.annualROI || 0)
  //               ...chart_resp.map((options) => options?.totalProfit || 0)
  //              );

  //              const maxUnfollowYValue = Math.max(
  //               100,
  //               ...chart_resp
  //                 .filter((options) => options.buttonLabel === "Unfollow")
  //                 // .map((options) => options?.annualROI || 0)
  //                 .map((options) => options?.totalProfit || 0)
  //             );

  //              setState((prev) => ({
  //                ...prev,
  //                series: [{ name: 'Profit', data: profitData }],
  //                options: {
  //                  ...prev.options,
  //                  xaxis: {
  //                    ...prev.options.xaxis,
  //                    categories: ["Start", "End"],
  //                  },
  //                  yaxis: {
  //                    ...prev.options.yaxis,
  //                    min: 0,
  //                    max: Math.ceil(maxYValue / 10) * 10,
  //                  },
  //                },
  //              }));
  //              setStateunfollow((prev) => ({
  //                ...prev,
  //                series: [{ name: 'Profit', data: profitData }],
  //                options: {
  //                  ...prev.options,
  //                  xaxis: {
  //                    ...prev.options.xaxis,
  //                    categories: ["Start", "End"],
  //                  },
  //                  yaxis: {
  //                    ...prev.options.yaxis,
  //                    min: 0,
  //                    max: Math.ceil(maxUnfollowYValue / 10) * 10,
  //                  },
  //                },
  //              }));

  //              setChartData((prevState) => ({
  //               ...prevState,
  //               series: [{ name: 'Profit', data: profitData }],
  //               options: {
  //                 ...prevState.options,
  //                 xaxis: { ...prevState.options.xaxis, categories }
  //               }
  //             }));
  //           }
  //         }

  //        } else {

  //          console.log("No data found, using defaults.");
  //          setState((prev) => ({
  //            ...prev,
  //            series: [
  //              {
  //                name: "Annual ROI",
  //                data: [0, 10],
  //              },
  //            ],
  //            options: {
  //              ...prev.options,
  //              xaxis: {
  //                ...prev.options.xaxis,
  //                categories: ["Start", "Target"],
  //              },
  //              yaxis: {
  //                ...prev.options.yaxis,
  //                min: 0,
  //                max: 100,
  //              },
  //            },
  //          }));
  //          setStateunfollow((prev) => ({
  //            ...prev,
  //            series: [
  //              {
  //                name: "Annual ROI",
  //                data: [0, 10],
  //              },
  //            ],
  //            options: {
  //              ...prev.options,
  //              xaxis: {
  //                ...prev.options.xaxis,
  //                categories: ["Start", "Target"],
  //              },
  //              yaxis: {
  //                ...prev.options.yaxis,
  //                min: 0,
  //                max: 100,
  //              },
  //            },
  //          }));
  //        }
  //       setStratagyList(response.data);
  //       setLoader(false);
  //     } else {
  //       setStratagyList(response.data);
  //       setLoader(false);
  //     }
  //     console.log(StratagyListref.current.length, "--==");
  //   } catch (error) {
  //     console.log(error, "-----------------");
  //     setLoader(false);
  //   }
  // };

  const getStratagy = async (data) => {
    try {
      setLoader(true);
      const token = localStorage.getItem("token");
      const response = await authService.topStratagies(token);
      setStratagyLoader(false);
      console.log(response, "response");
      if (response.status == true) {
        console.log(response.data, "response.data");
        if (response.data.length > 0) {
          const updatedSeries = response.data.map((options) => {
            //  const annualROI = options?.annualROI || 0;
            const annualROI = options?.profit_percentage || 0;
            console.log(annualROI, "annualROI");
            return {
              name: options.stratagyName || "Annual ROI",
              data: [0, annualROI],
              buttonLabel: options.buttonLabel || "Follow",
            };
          });

          const unFollowseries = response.data
            .filter((option, index) => option.buttonLabel === "Unfollow")
            .map((options, index) => {
              // const annualROI = options?.annualROI || 0;
              const annualROI = options?.profit_percentage || 0;
              return {
                name: options.stratagyName || "Annual ROI",
                data: [0, annualROI],
                buttonLabel: options.buttonLabel || "Follow",
              };
            });

          console.log("Upted series:", unFollowseries);

          const maxYValue = Math.max(
            100,
            //  ...response.data.map((options) => options?.annualROI || 0)
            ...response.data.map((options) => options?.profit_percentage || 0)
          );

          const maxUnfollowYValue = Math.max(
            100,
            ...response.data
              .filter((options) => options.buttonLabel === "Unfollow")
              // .map((options) => options?.annualROI || 0)
              .map((options) => options?.profit_percentage || 0)
          );

          setState((prev) => ({
            ...prev,
            series: updatedSeries,
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "End"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: Math.ceil(maxYValue / 10) * 10,
              },
            },
          }));
          setStateunfollow((prev) => ({
            ...prev,
            series: unFollowseries,
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "End"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: Math.ceil(maxUnfollowYValue / 10) * 10,
              },
            },
          }));
        } else {
          console.log("No data found, using defaults.");
          setState((prev) => ({
            ...prev,
            series: [
              {
                name: "Annual ROI",
                data: [0, 10],
              },
            ],
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "Target"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: 100,
              },
            },
          }));
          setStateunfollow((prev) => ({
            ...prev,
            series: [
              {
                name: "Annual ROI",
                data: [0, 10],
              },
            ],
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "Target"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: 100,
              },
            },
          }));
        }
        setStratagyList(response.data);
        setLoader(false);
      } else {
        setStratagyList(response.data);
        setLoader(false);
      }
      console.log(StratagyListref.current.length, "--==");
    } catch (error) {
      console.log(error, "-----------------");
      setLoader(false);
    }
  };

  const getFollowedStratagy = async (data) => {
    try {
      setLoader(true);
      const token = localStorage.getItem("token");
      const response = await authService.topStratagies(token);
      setStratagyLoader(false);
      console.log(response, "response");
      if (response.status == true) {
        if (response.data.length > 0) {
          const updatedSeries = response.data.map((options) => {
            //  const annualROI = options?.annualROI || 0;
            const annualROI = options?.profit_percentage || 0;
            console.log(annualROI, "annualROI");
            return {
              name: options.stratagyName || "Annual ROI",
              data: [0, annualROI],
              buttonLabel: options.buttonLabel || "Follow",
            };
          });

          const unFollowseries = response.data
            .filter((option, index) => option.buttonLabel === "Unfollow")
            .map((options, index) => {
              // const annualROI = options?.annualROI || 0;
              const annualROI = options?.profit_percentage || 0;
              return {
                name: options.stratagyName || "Annual ROI",
                data: [0, annualROI],
                buttonLabel: options.buttonLabel || "Follow",
              };
            });

          console.log("Updated series:", unFollowseries);

          const maxYValue = Math.max(
            100,
            //  ...response.data.map((options) => options?.annualROI || 0)
            ...response.data.map((options) => options?.profit_percentage || 0)
          );

          const maxUnfollowYValue = Math.max(
            100,
            ...response.data
              .filter((options) => options.buttonLabel === "Unfollow")
              // .map((options) => options?.annualROI || 0)
              .map((options) => options?.profit_percentage || 0)
          );

          setState((prev) => ({
            ...prev,
            series: updatedSeries,
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "End"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: Math.ceil(maxYValue / 10) * 10,
              },
            },
          }));
          setStateunfollow((prev) => ({
            ...prev,
            series: unFollowseries,
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "End"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: Math.ceil(maxUnfollowYValue / 10) * 10,
              },
            },
          }));
        } else {
          console.log("No data found, using defaults.");
          setState((prev) => ({
            ...prev,
            series: [
              {
                name: "Annual ROI",
                data: [0, 10],
              },
            ],
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "Target"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: 100,
              },
            },
          }));
          setStateunfollow((prev) => ({
            ...prev,
            series: [
              {
                name: "Annual ROI",
                data: [0, 10],
              },
            ],
            options: {
              ...prev.options,
              xaxis: {
                ...prev.options.xaxis,
                categories: ["Start", "Target"],
              },
              yaxis: {
                ...prev.options.yaxis,
                min: 0,
                max: 100,
              },
            },
          }));
        }
        setStratagyList(response.data);
        setLoader(false);
      } else {
        setStratagyList(response.data);
        setLoader(false);
      }
      console.log(StratagyListref.current.length, "--==");
    } catch (error) {
      setLoader(false);
      console.log(error, "-----------------");
    }
  };

  const getPlanDetails = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await authService.getPlanDetails(token);
      setLoading(false);
      if (response.data && Array.isArray(response.data)) {
        setPlanDetails(response.data);
      } else {
        setPlanDetails([]);
        localStorage.setItem("freemiumActivated", false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching plan details:", error);
    }
  };

  const fetchUserDetails = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            botStatus: data.botStatus,
            exchanges: data.exchanges,
            botActivatedAt: data.botActivatedAt,
            botDeactivatedAt: data.botDeactivatedAt,
          };
          setUser(userDetails);
        } else {
          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            exchanges: [],
            botActivatedAt: null,
            botDeactivatedAt: null,
            referralCode: null,
            referralUrl: null,
          });
        }
      } catch (error) {
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          exchanges: [],
          referralCode: null,
          referralUrl: null,
          botActivatedAt: null,
          botDeactivatedAt: null,
        });
      }
    } else {
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        botActivatedAt: null,
        botDeactivatedAt: null,
      });
    }
    setLoading(false);
  };

  const fetchBalance = async () => {
    try {
      // const response = await authService.getTransactions();
      const response = await authService.getAssets();
      console.log("fetchBalance", response);
      setLoader(true);
      if (response.status) {
        setFuelWallet(parseFloat(response?.userWalletFuelAmount) || 0);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  };

  const showsuccessToast = (message) => {
    toast.dismiss();
    toast.success(
      <div className="toast-ml">
        <h4 className="toast-title">Success!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const showerrorToast = (message) => {
    toast.dismiss();
    toast.error(
      <div className="toast-ml">
        <h4 className="toast-title">Error!</h4>
        <p className="toast-message">{message}</p>
      </div>
    );
  };

  const handleFollowStrategy = async (data) => {
    try {
      setLoader(true);

      const minBalanceRequired =
        planDetails.length > 0 ? planDetails[0].min_fuel : "$100";

      const numericMinBalanceRequired =
        parseFloat(minBalanceRequired.replace("$", "")) || 0;

      const numericFuelWallet = parseFloat(fuelWallet) || 0;
      if (
        user?.botStatus == "Active" ||
        numericFuelWallet >= numericMinBalanceRequired
      ) {
        var obj = {
          action: data.buttonLabel,
          strategyId: data._id,
        };
        const response = await authService.handleFollowStrategy(obj);
        setLoader(false);
        const message = response.Message?.trim();
        if (message === "Strategy is Followed") {
          showsuccessToast(response.Message);
          getStratagy();
          setLoader(false);
        } else if (message === "Strategy is Unfollowed") {
          console.log(message, "response.Message");
          showsuccessToast(response.Message);
          getStratagy();
          setLoader(false);
        } else {
          showerrorToast(response.Message);
          setLoader(false);
        }
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      } else {
        if (numericFuelWallet < numericMinBalanceRequired) {
          showerrorToast(
            `Insufficient fuel wallet balance. A minimum of $${numericMinBalanceRequired} is required.`
          );
          setLoader(false);
          return;
        }
      }
    } catch (err) {
      setTimeout(() => {
        setLoader(false);
        console.log("call here 111", err);
      }, 1000);
    }
  };

  const openModal = (value) => {
    setStrategyDetails(value);
    console.log("strategy value===", value);
    setIsModalOpen(true);
  };

  const handleModalclose = async () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <section>
        <Header />
      </section>
      
      <div className="asset_row_resp">
        <div className="container">
          <div className="home_main">
            <div className="row starteg_main">
              <div className="col-xl-6 col-lg-8 col-md-10 col-sm-12">
                <span className="startegy_top_center">
                  Master the Market with Proven Strategies for Success
                </span>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 p-0 pad-0-560">
                <div className="startegy_first_main">
                  <span className="home_botstatus_span">Top Strategies</span>

                  {loader ? (
                    <div className="loader_main loader_mainChange">
                      <ScaleLoader color="#20A1FD" height={10} width={3} />
                      <p>Loading...</p>
                    </div>
                  ) : (
                    <div className="row g-4">
                      {StratagyListref.current.length > 0
                        ? StratagyListref.current.map((options, index) => {
                            return (
                              <div className="col-lg-3 col-md-6 pad-0-560">
                                <div className="strategy_topstarty_inmain">
                                  <div className="startegy_topstary_inntop">
                                    <div className="top_startgy_intopintop">
                                      <div className="newsra_po_chn">
                                        <span className="dca_main">
                                          {" "}
                                          {options.stratagyName}
                                        </span>
                                        <i
                                          className="fa-regular fa-circle-question"
                                          onClick={() => openModal(options)}
                                        ></i>
                                      </div>
                                      <div className="reg_check_main">
                                        <div className="">
                                          <img
                                            src={require("../assests/icons/topstartegy-users.png")}
                                            alt="Users"
                                            className="topstartegy-users"
                                          />
                                          <span className="top-99">
                                            {" "}
                                            {options.strategy_count}
                                            {/* {options.followers} */}
                                          </span>
                                        </div>
                                        {/* <div className="topstartegy_color_div">
                        <span>
                          ROI: {options.leverage}X
                        </span>
                      </div> */}
                                      </div>
                                    </div>
                                    <div className="startgy_box_intopinbottom">
                                      <div className="top_startgy_inbottomleft">
                                        <span className="top_startgy_inbottomadvance">
                                          Monthly ROI
                                        </span>
                                        <span className="top_startgy_inbottompercen">
                                          {options.profit_percentage}%
                                        </span>
                                      </div>
                                      <div id="chart" className="chart_main">
                                        <ReactApexChart
                                          options={state.options}
                                          series={
                                            state.series[index]
                                              ? [state.series[index]]
                                              : []
                                          }
                                          type="area"
                                          height={130}
                                        />

                                        {/* <ReactApexChart
                        options={chartData.options}
                        series={chartData.series}
                        type="line" // Change to 'bar', 'area', or others as needed
                        height={130}
                      /> */}
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="home_topstary_follow"
                                    onClick={() =>
                                      handleFollowStrategy(options)
                                    }
                                  >
                                    <span>{options.buttonLabel}</span>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        : ""}
                    </div>
                  )}
                  {/* {StratagyLoader == true ? (
                    <span className="home_loading">Loading....</span>
                  ) : (
                    
                  )} */}
                </div>
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-lg-12 p-0">
                <div className="startegy_first_main">
                  <span className="home_botstatus_span">
                    Followed strategies
                  </span>

                  <div className="row">
                    {StratagyListref.current.length > 0 ? (
                      StratagyListref.current.filter(
                        (option) => option.buttonLabel === "Unfollow"
                      ).length > 0 ? (
                        StratagyListref.current
                          .filter((option) => option.buttonLabel === "Unfollow")
                          .map((options, index) => {
                            return (
                              <div className="col-lg-3 col-md-6 pad-0-560">
                                <div className="strategy_topstarty_inmain">
                                  <div className="startegy_topstary_inntop">
                                    <div className="top_startgy_intopintop">
                                      <div className="newsra_po_chn">
                                        <span className="dca_main">
                                          {" "}
                                          {options.stratagyName}
                                        </span>
                                        <i
                                          className="fa-regular fa-circle-question"
                                          onClick={() => openModal(options)}
                                        ></i>
                                      </div>
                                      <div className="reg_check_main">
                                        <div className="">
                                          <img
                                            src={require("../assests/icons/topstartegy-users.png")}
                                            alt="Users"
                                            className="topstartegy-users"
                                          />
                                          <span className="top-99">
                                            {" "}
                                            {options.strategy_count}
                                            {/* {options.followers} */}
                                          </span>
                                        </div>
                                        {/* <div className="topstartegy_color_div">
                                          <span>
                                            ROI: {options.leverage}X
                                          </span>
                                        </div> */}
                                      </div>
                                    </div>
                                    <div className="startgy_box_intopinbottom">
                                      <div className="top_startgy_inbottomleft">
                                        <span className="top_startgy_inbottomadvance">
                                          Monthly ROI
                                        </span>
                                        <span className="top_startgy_inbottompercen">
                                          {options.profit_percentage}%
                                        </span>
                                      </div>

                                      <div
                                        id="chart"
                                        className="chart_main"
                                        style={{
                                          position: "relative",
                                          top: "21px",
                                          right: "0px",
                                        }}
                                      >
                                        <ReactApexChart
                                          options={stateunfollow.options}
                                          series={
                                            stateunfollow.series[index]
                                              ? [stateunfollow.series[index]]
                                              : []
                                          }
                                          type="area"
                                          height={130}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div className="no-strategies">
                          <h3>No followed strategies</h3>
                        </div>
                      )
                    ) : (
                      <div className="no-strategies">
                        <h3>No followed strategies</h3>
                      </div>
                    )}
                  </div>

                  {/* <div className="col-lg-3 col-md-6 m-top-20-770 pad-0-560">
                    <div className="strategy_topstarty_inmain">
                        <div className="startegy_topstary_inntop">
                            <div className="top_startgy_intopintop">
                                <span className="dca_main"> Intra Strategy</span>
                                <div className="reg_check_main">
                                    <div className="">
                                    <img
                                    src={require("../assests/icons/topstartegy-users.png")}
                                    alt="Users"
                                    className="topstartegy-users"
                                  />
                                  <span className="top-99"> 99</span>
                                    </div>
                                    <div className="topstartegy_color_div">
                                  <span>Profit: 3X</span>
                                </div>
                                </div>
                                </div>
                                <div className="startgy_box_intopinbottom">
                                    <div className="top_startgy_inbottomleft">
                                    <span className="top_startgy_inbottomadvance">
                                  Monthly ROI
                                </span>
                                <span className="top_startgy_inbottompercen">
                                  536.49%
                                </span>
                                    </div>
                                    <img
                                src={require("../assests/topstrategy-chart.png")}
                                alt="Startegy chart"
                                className="startegy_chart_strategybox"
                              />
                                
                            </div>
                        </div>
                        <div className="home_topstary_follow">
                          <span>Un Follow</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 m-top-20 pad-0-560">
                    <div className="strategy_topstarty_inmain">
                        <div className="startegy_topstary_inntop">
                            <div className="top_startgy_intopintop">
                                <span className="dca_main"> Triangle Strategy</span>
                                <div className="reg_check_main">
                                    <div className="">
                                    <img
                                    src={require("../assests/icons/topstartegy-users.png")}
                                    alt="Users"
                                    className="topstartegy-users"
                                  />
                                  <span className="top-99"> 99</span>
                                    </div>
                                    <div className="topstartegy_color_div">
                                  <span>Profit: 3X</span>
                                </div>
                                </div>
                                </div>
                                <div className="startgy_box_intopinbottom">
                                    <div className="top_startgy_inbottomleft">
                                    <span className="top_startgy_inbottomadvance">
                                  Monthly ROI
                                </span>
                                <span className="top_startgy_inbottompercen">
                                  536.49%
                                </span>
                                    </div>
                                    <img
                                src={require("../assests/topstrategy-chart.png")}
                                alt="Startegy chart"
                                className="startegy_chart_strategybox"
                              />
                                
                            </div>
                        </div>
                        <div className="home_topstary_follow">
                          <span>Un Follow</span>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6 m-top-20 pad-0-560">
                    <div className="strategy_topstarty_inmain">
                        <div className="startegy_topstary_inntop">
                            <div className="top_startgy_intopintop">
                                <span className="dca_main"> Arbitrage Strategy</span>
                                <div className="reg_check_main">
                                    <div className="">
                                    <img
                                    src={require("../assests/icons/topstartegy-users.png")}
                                    alt="Users"
                                    className="topstartegy-users"
                                  />
                                  <span className="top-99"> 99</span>
                                    </div>
                                    <div className="topstartegy_color_div">
                                  <span>Profit: 3X</span>
                                </div>
                                </div>
                                </div>
                                <div className="startgy_box_intopinbottom">
                                    <div className="top_startgy_inbottomleft">
                                    <span className="top_startgy_inbottomadvance">
                                  Monthly ROI
                                </span>
                                <span className="top_startgy_inbottompercen">
                                  536.49%
                                </span>
                                    </div>
                                    <img
                                src={require("../assests/topstrategy-chart.png")}
                                alt="Startegy chart"
                                className="startegy_chart_strategybox"
                              />
                                
                            </div>
                        </div>
                        <div className="home_topstary_follow">
                          <span>Un Follow</span>
                        </div>
                      </div>
                    </div> */}

                  {isModalOpen && (
                    <div
                      className="modal fade show"
                      style={{ display: "block" }}
                      tabIndex="-1"
                      role="dialog"
                    >
                      <div class="modal-dialog modal-dialog-centered modal-md">
                        <div class="modal-content">
                          <div class="modal-header lvl-one-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">
                              <span className="home_user_display">
                                {/* <img
                              src={require("../assests/icons/account-details.png")}
                              alt="Acount details"
                              className="profile_subheads_logo mb-1 mx-2"
                            />{" "} */}
                                Strategy details
                              </span>
                            </h1>
                            <button
                              type="button"
                              class="btn-close btn-close-custom nestra_poo_hea"
                              data-bs-dismiss="modal"
                              aria-label="Close"
                              onClick={() => handleModalclose()}
                            ></button>
                          </div>
                          <div className="modal-body personal_verify_body lvl-one-body">
                            <div className="mt-2 d-flex flex-column gap-3">
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  <span>Minimum exchanges required :</span>{" "}
                                  {strategyDetails.min_exchange}
                                </span>
                              </div>
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  <span>Minimum deposit required :</span>{" "}
                                  {strategyDetails.min_deposit} USDT
                                </span>
                              </div>
                              <div className="profile_edit_inpmain">
                                <span className="home-viewasset-span">
                                  <span>Minimum fuel required :</span>{" "}
                                  {strategyDetails.min_fuel} USDT
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <section className="footer_section">
              <div className="container">
                <section className="row mx-0 bn-footer-row g-4 g-lg-1">
                  <div className="col-lg-6 col-sm-6 col-12">
                    <div>
                      <img
                        src={require("./img/footer-logo.webp")}
                        alt=""
                        className="bn-footer-logo"
                      />
                      <p className="bn-footer-logo-content">
                        AI-powered crypto trading bot with blockchain security
                        for seamless and automated trading.
                      </p>
                    </div>
                  </div>
                  <div className="col-lg-2 col-sm-4 col-6">
                    <h6 className="bn-footer-link-title">Explore</h6>
                    <ul className="bn-footer-lists">
                      {/* <li>
                        <Link to="/" className="bn-footer-links">
                          Newbies
                        </Link>
                      </li>
                      <li>
                        <Link to="/" className="bn-footer-links">
                          Knowledge Base
                        </Link>
                      </li>
                      <li>
                        <Link to="/" className="bn-footer-links">
                          Strategies
                        </Link>
                      </li> */}
                      <li>
                        <Link to="/termscondition" className="bn-footer-links">
                          Terms and Service
                        </Link>
                      </li>
                      <li>
                        <Link to="/privacypolicy" className="bn-footer-links">
                          Privacy Policy
                        </Link>
                      </li>
                    </ul>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-6">
                    <h6 className="bn-footer-link-title">Support</h6>
                    <ul className="bn-footer-lists">
                      {/* <li>
                                   <Link to="/" className="bn-footer-links">
                                     Terms & Conditions
                                   </Link>
                                 </li>
                                 <li>
                                   <Link to="/" className="bn-footer-links">
                                     Privacy Policy
                                   </Link>
                                 </li> */}
                      <li>
                        <Link to="/support" className="bn-footer-links">
                          Help Center
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="col-lg-2 col-sm-6 col-6">
                    <h6 className="bn-footer-link-title">Social</h6>
                    <ul className="bn-footer-icon-wrap">
                      <li>
                        <a target="_blank" href={siteDatacomes.instagram}>
                          <img src={require("./img/instagram.webp")} alt="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" href={siteDatacomes.twitter}>
                          <img src={require("./img/x.webp")} alt="" />
                        </a>
                      </li>
                      <li>
                        <a target="_blank" href={siteDatacomes.telegram}>
                          <img src={require("./img/telegram.webp")} alt="" />
                        </a>
                      </li>
                    </ul>
                  </div>
                </section>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Strategies;
